import React from 'react';

const steps = [
  {
    number: 1,
    title: 'Manage Brand Kit',
    description: 'Add your logos and watermarks to personalize your brand kit',
  },
  {
    number: 2,
    title: 'Set Active Kit',
    description: 'Choose your active brand kit for document processing',
  },
  {
    number: 3,
    title: 'Upload Document',
    description: 'Upload any PDF, Word doc, or PowerPoint presentation',
  },
  {
    number: 4,
    title: 'Download Branded',
    description: 'Get your professionally branded document ready to share',
  },
];

export default function HowToUse() {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
      <h2 className="text-lg font-semibold text-gray-800 mb-6 text-center">How to Use Rebrand Studio</h2>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {steps.map((step, index) => (
          <div key={step.number} className="text-center relative">
            {index < steps.length - 1 && (
              <div className="hidden lg:block absolute top-1/2 left-full w-full h-px -translate-y-1/2 -ml-4">
                <svg className="w-full h-full text-gray-200" preserveAspectRatio="none" viewBox="0 0 100 1">
                  <path d="M 0,0.5 L 100,0.5" stroke="currentColor" strokeWidth="2" strokeDasharray="4 4" />
                </svg>
              </div>
            )}
            <div className="w-12 h-12 flex items-center justify-center bg-gray-100 text-blue-600 font-bold text-xl rounded-full mx-auto mb-4 border-2 border-gray-200">
              {step.number}
            </div>
            <h3 className="font-semibold text-gray-900 mb-2">{step.title}</h3>
            <p className="text-sm text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}